import { useEffect } from "react";
import { useOnboardingStore } from "@/stores/onboardingStore";
import { StepCompanyForm } from "./StepCompanyForm";
import { StepTeammateRequested } from "./StepTeammateRequested";

// Step 2 switcher — the `verify-email` response carries `domain_exists`.
// If the domain already has a VirtualDesk workspace, we show a single
// confirmation card to request teammate access. Otherwise we show the
// company-info form.
export function StepDomainBranch() {
  const domainExists = useOnboardingStore((s) => s.domainExists);
  const step = useOnboardingStore((s) => s.step);
  const setStep = useOnboardingStore((s) => s.setStep);

  // When we land on domain-branch for the first time, pick the concrete
  // sub-step based on the flag so a reload drops the user back in place.
  useEffect(() => {
    if (step !== "domain-branch") return;
    setStep(domainExists ? "teammate-requested" : "company-form");
  }, [step, domainExists, setStep]);

  if (step === "teammate-requested") return <StepTeammateRequested />;
  if (step === "company-form") return <StepCompanyForm />;
  // Transitional render (one tick) — keep the card shape for smoothness.
  return domainExists ? <StepTeammateRequested /> : <StepCompanyForm />;
}
